export default __webpack_public_path__ + "static/media/logo.0bd08c90.jpg";